<app-tasksfilter class="flex-control flex-column" [patient]="patient" [isPatientProfile]="true"></app-tasksfilter>
